import store from '@state/store';
import config from '@src/config';

const redirectPathForAuthUsers = () => {
  store.dispatch('auth/validateToken');

  const token = store.getters['auth/token'];
  const currentUser = store.getters['auth/user'];
  const userPermissions = store.getters['auth/permissions'];
  const page404 = '404';
  const adminDashboard = 'users';
  const userDashboard = 'orders';
  const restoAdminDashboard = 'branches';
  const historyRoute = 'history';

  let redirectPath;

  if (token && token.access_token) {
    redirectPath = page404;
  }

  if (userPermissions.includes('can_crud_orders')) {
    redirectPath = userDashboard;
  } else if (userPermissions.includes('can_crud_users')) {
    redirectPath = adminDashboard;
  } else if (currentUser && currentUser.is_resto_admin) {
    redirectPath = restoAdminDashboard;
  } else if (userPermissions.includes(config.PERMISSIONS.CAN_CRUD_HISTORIES)) {
    redirectPath = historyRoute;
  } else {
    redirectPath = page404;
  }

  return redirectPath;
};

export default [
  {
    path: '/',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    beforeEnter(routeTo, routeFrom, next) {
      store.dispatch('auth/validateToken');
      const token = store.getters['auth/token'];

      if (token && token.access_token) {
        const redirectPath = redirectPathForAuthUsers();
        next({ name: redirectPath });
      } else {
        next();
      }
    },
  },
  {
    path: '/reg',
    name: 'registration',
    component: () => lazyLoadView(import('@views/registration')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_USERS,
    },
  },
  {
    path: '/users',
    name: 'users',
    component: () => lazyLoadView(import('@views/admin-dashboard/users/users')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_USERS,
    },
    props: route => ({
      user: store.state.auth.user,
    }),
  },
  {
    path: '/users/create/',
    name: 'create-user',
    component: () => lazyLoadView(import('@views/admin-dashboard/users/createUser')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_USERS,
    },
    props: true,
  },
  {
    path: '/users/edit/:userid',
    name: 'edit-user',
    component: () => lazyLoadView(import('@views/admin-dashboard/users/createUser')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_USERS,
    },
    props: true,
  },
  {
    path: '/roles',
    name: 'roles',
    component: () => lazyLoadView(import('@views/admin-dashboard/roles/roles')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_ROLES,
    },
    props: route => ({
      user: store.state.auth.user,
    }),
  },
  {
    path: '/roles/create',
    name: 'create-role',
    component: () => lazyLoadView(import('@views/admin-dashboard/roles/createRole')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_ROLES,
    },
    props: true,
    // props: route => ({
    //   user: store.state.auth.user,
    // }),
  },
  {
    path: '/roles/edit/:roleid',
    name: 'edit-role',
    component: () => lazyLoadView(import('@views/admin-dashboard/roles/createRole')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_ROLES,
    },
    props: true,
  },
  {
    path: '/permissions',
    name: 'permissions',
    component: () => lazyLoadView(import('@views/admin-dashboard/permissions/permissions')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_PERMISSIONS,
    },
    props: route => ({
      user: store.state.auth.user,
    }),
  },
  {
    path: '/permissions/create',
    name: 'create-permissions',
    component: () => lazyLoadView(import('@views/admin-dashboard/permissions/createPermission')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_PERMISSIONS,
    },
    props: true,
  },
  {
    path: '/permissions/edit/:permid',
    name: 'edit-permissions',
    component: () => lazyLoadView(import('@views/admin-dashboard/permissions/createPermission')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_PERMISSIONS,
    },
    props: true,
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => lazyLoadView(import('@views/user-dashboard/orders')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_ORDERS,
    },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => lazyLoadView(import('@views/user-dashboard/notifications')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_ORDERS,
    },
  },
  {
    path: '/my-restaurant',
    name: 'my-restaurant',
    component: () => lazyLoadView(import('@views/user-dashboard/myRestaurant')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_MY_RESTAURANT,
    },
    // props: route => ({
    //   user: store.state.auth.user,
    // }),
  },
  {
    path: '/menu',
    name: 'menus',
    component: () => lazyLoadView(import('@views/user-dashboard/menus')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_MENUS,
    },
    // props: route => ({
    //   user: store.state.auth.user,
    // }),
  },
  {
    path: '/history',
    name: 'history',
    component: () => lazyLoadView(import('@views/user-dashboard/history')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_HISTORIES,
    },
    // props: route => ({
    //   user: store.state.auth.user,
    // }),
  },
  {
    path: '/business-hours',
    name: 'business-hours',
    component: () => lazyLoadView(import('@views/user-dashboard/business-hours')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_ORDERS,
    },
    // props: route => ({
    //   user: store.state.auth.user,
    // }),
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => lazyLoadView(import('@views/user-dashboard/activity')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_SEE_ACTIVITY_LOGS,
    },
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: () => lazyLoadView(import('@views/user-dashboard/downloads')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.CAN_CRUD_HISTORIES,
    },
  },
  {
    path: '/reset-password',
    name: 'reset-pass',
    component: () => lazyLoadView(import('@views/resetPassword')),
    meta: {
      authRequired: true,
      permission: [ config.PERMISSIONS.CAN_CRUD_HISTORIES, config.PERMISSIONS.CAN_CRUD_USERS, config.PERMISSIONS.IS_RESTO_ADMIN ],
    },
  },
  {
    path: '/branches',
    name: 'branches',
    component: () => lazyLoadView(import('@views/resto-admin-dashboard/branches')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.IS_RESTO_ADMIN,
    },
  },
  {
    path: '/branch/:id/detail',
    name: 'branch',
    component: () => lazyLoadView(import('@views/resto-admin-dashboard/branch')),
    meta: {
      authRequired: true,
      permission: config.PERMISSIONS.IS_RESTO_ADMIN,
    },
  },
  // {
  //   path: '/profile',
  //   name: 'profile',
  //   component: () => lazyLoadView(import('@views/profile')),
  //   meta: {
  //     authRequired: true,
  //   },
  //   props: route => ({
  //     user: store.state.auth.user,
  //   }),
  // },
  {
    path: '/404',
    name: '404',
    component: require('@views/404').default,
  },
  {
    path: '/logout',
    name: 'logout',
    component: require('@views/logout').default,
  },
  {
    path: '*',
    redirect: '404',
  },
];

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@views/loading').default,
    error: require('@views/timeout').default,
    delay: 400,
    timeout: 10000,
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children);
    },
  });
}
